import type { PropsWithChildren } from "react";
import { createContext } from "react";

import { useNonNullableContext } from "app/common";
import type { ListParams } from "app/pages/sales-intelligence/domain/lists/types/list";

type ListParamsProviderProps = PropsWithChildren<{
    value: ListParams;
}>;

const ListParamsContext = createContext<ListParams | undefined>(undefined);

export const ListParamsProvider = ({ value, children }: ListParamsProviderProps) => {
    return <ListParamsContext.Provider value={value}>{children}</ListParamsContext.Provider>;
};

export const useListParams = (): ListParams => useNonNullableContext(ListParamsContext);
